export default "__VITE_ASSET__09e03bc7__"